import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import MsalBootstrap from "@msal/MsalBootstrap";
import "@/styles/index.scss";
import {bootstrapI18n} from "@i18n/bootstrap";
import {installConsoleGate} from "@/console";
import {initGtmTracking} from "@lib/gtm";

const analyticsEnabled = globalThis.__GTM_ENABLED__ === true;
const siteEnabled = import.meta.env.VITE_SITE_ENABLED === "1" || localStorage.getItem("_show_prod");

installConsoleGate();
bootstrapI18n();

if (analyticsEnabled) {
    initGtmTracking();
}

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
    <React.StrictMode>
        {siteEnabled
            ? (
                <MsalBootstrap>
                    <App/>
                </MsalBootstrap>
            )
            : <HiddenSite/>
        }
    </React.StrictMode>
);

function HiddenSite() {
    return (
        <div aria-disabled={true} style={{display: "none"}}>hi</div>
    );
}